import React, { useCallback, useMemo } from 'react';
import { useSmartLinkActions } from '@atlaskit/smart-card/hooks';
export var PreviewInvoker = function PreviewInvoker(_ref) {
  var url = _ref.url,
    appearance = _ref.appearance,
    children = _ref.children;
  var actions = useSmartLinkActions({
    url: url,
    appearance: appearance
  });
  var preview = useMemo(function () {
    return actions.find(function (action) {
      return action.id === 'preview-content';
    });
  }, [actions]);
  var invokePreview = useCallback(function () {
    try {
      preview === null || preview === void 0 || preview.invoke();
    } catch (_unused) {}
  }, [preview]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children({
    canPreview: !!preview,
    invokePreview: invokePreview
  }));
};